import { render, staticRenderFns } from "./user-nav.vue?vue&type=template&id=8c3c52c2"
import script from "./user-nav.vue?vue&type=script&lang=js"
export * from "./user-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports